import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const getAllLocations = {
  name: 'getAllLocations',
  state: {
    data: [],
    loading: false,
    error: '',
    totalCount: 0,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
      };
    },

    getReceived(state, payload) {
      const locationData = payload.data.map(item => ({
        id: item.id,
        // eslint-disable-next-line 
        location_address: `${item.location_name},${item.address}`,
        address: item.address,
        location_name: item.location_name,
        longitude: item.location.longitude,
        latitude: item.location.latitude
      }));
      return {
        ...state,
        data: locationData,
        loading: false,
        error: '',
        totalCount: payload.totalCount || 0,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async allLocations() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        const url = `savvy/locations/lookup/${orgId}`;
        this.getRequested();
        const response = await http.get(url);
        if (response && response.data) {
          this.getReceived({
            data: response.data.data,
            totalCount: response.data.data.length,
          });
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default getAllLocations;
